<template>
  <d-container
    fluid
    class="main-content-container px-4">
    <!-- Page Header -->
    <div class="page-header-with-filters">
      <d-row
        no-gutters
        class="page-header py-4">
        <d-col
          col
          sm="6"
          class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">{{ $t('agents.agentsLabel') }}</span>
          <h3 class="page-title">{{ $t('agents.agentsList') }}</h3>
        </d-col>
        <d-col
          col
          sm="6"
          class="text-right text-sm-right d-flex justify-content-end align-items-end">
          <d-button
            theme="success"
            @click.prevent="$router.push('/agenci/nowy')">
            <i class="material-icons">add</i>
            {{ $t('agents.addAgent') }}
          </d-button>
        </d-col>
      </d-row>

      <list-filters
        :config="filtersConfig"
        :isListLoaded="loaded"
        :view-name="'agents'"
        @init="handleFiltersInit"
        @search="handleFiltersSearch" />
    </div>

    <d-card style="width: 100%;">
      <table class="table mt-0 mb-0 full-width">
        <thead class="bg-light">
          <tr>
            <th
              scope="col"
              class="border-0">{{ $t('ui.name') }}</th>
            <th
              scope="col"
              class="border-0">{{ $t('agents.commission') }}</th>
            <th
              scope="col"
              class="border-0">{{ $t('ui.actions') }}</th>
          </tr>
        </thead>
        <tbody v-if="loaded">
          <tr
            v-for="(agent, index) of agents"
            :key="'agent-' + index">
            <td class="align-middle">
              {{ agent.name }}
            </td>
            <td class="align-middle">
              {{ agent.commission }}%
            </td>
            <td
              class="align-middle"
              style="width: 150px;">
              <d-button
                theme="primary"
                @click.native="$router.push('/agenci/edycja/' + agent.id)"
                class="mr-2"
                :title="$t('ui.edit')">
                <i class="material-icons">edit</i>
              </d-button>
              <d-button
                theme="danger"
                :disabled="removeInProgress"
                @click.native="removeAgent(agent.id)"
                :title="$t('ui.delete')">
                <i class="material-icons">delete</i>
              </d-button>
            </td>
          </tr>
          <tr v-if="agents.length === 0">
            <td
              colspan="5"
              class="text-center">
              {{ $t('agents.noAgentsToDisplay') }}&hellip;
            </td>
          </tr>
        </tbody>
      </table>

      <div
        v-if="!loaded"
        class="pb-3 pt-3 text-center">
        {{ $t('ui.dataLoading') }}&hellip;
      </div>

      <d-alert
        v-if="loadError"
        show
        theme="warning">
        {{ $t('ui.dataLoadingFailed') }} <a
          href="javascript:window.location.reload();"
        class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
      </d-alert>
    </d-card>

    <pagination
      :meta-data="paginationMetaData"
      :initial-page="currentPage" />
  </d-container>
</template>

<script>
import debounce from 'lodash.debounce';
import cloneDeep from 'lodash.clonedeep';
import HasPagination from './../mixins/HasPagination.vue';
import ListUtils from './../utils/ListUtils.js';
import Pagination from './../components/common/Pagination.vue';

export default {
  name: 'agents',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination
  },
  computed: {
    filtersConfig () {
      return [
        {
          key: 'search',
          label: this.$t('ui.search'),
          placeholder: this.$t('agents.agentsSearchPlaceholder'),
          type: 'text',
          isBasic: true,
          defaultValue: ''
        }
      ];
    }
  },
  data () {
    return {
      agents: [],
      loaded: false,
      loadError: false,
      removeInProgress: false,
      activeFilters: {},
      apiQueryPayload: {}
    };
  },
  mounted () {},
  methods: {
    handleFiltersInit (filters, apiPayload) {
      this.activeFilters = filters;
      this.apiQueryPayload = apiPayload;

      this.loadFilteredData();
    },
    handleFiltersSearch (activeFilters, apiPayload) {
      this.activeFilters = activeFilters;
      this.apiQueryPayload = apiPayload;
      this.$bus.$emit('pagination-reset');
      this.debouncedLoadFilteredData();
    },
    debouncedLoadFilteredData: debounce(function () {
      this.loadFilteredData();
    }, 250),
    loadFilteredData () {
      let where = cloneDeep(this.apiQueryPayload) || {};

      ListUtils.loadPaginatedItemsData(this, {
        endpoint: '/agents/items?page=' + this.currentPage,
        listField: 'agents',
        params: {
          where
        }
      });
    },
    removeAgent (agentID) {
      this.removeInProgress = true;

      ListUtils.removeItem({
        $http: this.$http,
        endpointBase: '/agents/delete/',
        id: agentID,
        successTitle: this.$t('agents.deleteSuccessTitle'),
        successText: this.$t('agents.deleteSuccessText'),
        confirmTitle: this.$t('agents.deleteConfirmTitle'),
        confirmText: this.$t('ui.deleteConfirmText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('agents.deleteErrorText'),
        successAction: () => {
          this.removeInProgress = false;
          this.loadFilteredData();
        },
        cancelAction: () => {
          this.removeInProgress = false;
        }
      });
    }
  }
};
</script>
